export function calculateResults(questionSet, answers) {
  const partyAnswers = Map.groupBy(
    questionSet.partyOpinions,
    ({ statementId }) => statementId,
  );

  const matches = Object.entries(answers).reduce(
    (acc, [questionID, answer]) => {
      partyAnswers.get(questionID).forEach(({ partyId, opinion }) => {
        if (answer === opinion) acc.set(partyId, (acc.get(partyId) || 0) + 1);
      });

      return acc;
    },
    new Map(),
  );

  const total = Object.entries(answers).length;
  return questionSet.parties
    .map(({ _id, name }) => {
      const count = matches.get(_id) || 0;
      const percentage = total === 0 ? 0 : (count / total) * 100;

      return { partyName: name, percentage };
    })
    .sort((r1, r2) => r2.percentage - r1.percentage);
}
